import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FindPasswordForm from "../components/FindPasswordForm";
import {
  verifyUserRequested,
  resetPasswordRequested,
  findPasswordCleared,
  selectAuth,
} from "../slice";

export default function FindPasswordContainer() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const {
    verifyStatus, verifyError, resetToken,
    resetStatus, resetError,
  } = useSelector(selectAuth);

  useEffect(() => {
    dispatch(findPasswordCleared());
  }, [dispatch]);

  useEffect(() => {
    if (resetStatus === "succeeded") {
      alert("비밀번호가 변경되었습니다. 새 비밀번호로 로그인해주세요.");
      dispatch(findPasswordCleared());
      nav("/login");
    }
  }, [resetStatus, dispatch, nav]);

  return (
    <div className="loginfield">
      <FindPasswordForm
        onVerify={(p) => dispatch(verifyUserRequested(p))}
        onReset={({ password }) =>
          dispatch(resetPasswordRequested({ reset_token: resetToken, new_password: password }))
        }
        verifyLoading={verifyStatus === "loading"}
        verifyError={verifyError}
        verified={verifyStatus === "succeeded" && !!resetToken}
        resetLoading={resetStatus === "loading"}
        resetError={resetError}
      />
    </div>
  );
}
